
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/my-tutor",
      function () {
        return require("private-next-pages/student/my-tutor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/my-tutor"])
      });
    }
  